import { create } from 'zustand'

export { useSelectedTabStore }

const useSelectedTabStore = () => {
  const selectedTab = useStore((state) => state.selectedTab)
  const storeSelectedTab = useStore((state) => state.storeSelectedTab)

  return { selectedTab, storeSelectedTab }
}

const useStore = create<{
  selectedTab: string
  storeSelectedTab: (selectedTab: string) => void
}>((set) => ({
  selectedTab: 'processtappen',
  storeSelectedTab: (selectedTab) =>
    set((state) => ({ ...state, selectedTab: selectedTab })),
}))
